const niceResultName = "nice_result";

const setNiceResultInLocalStorage = (data) => {
    let stringData = JSON.stringify(data);
    return localStorage.setItem(niceResultName, stringData);
};

const getlocalStorageNiceResult = () => {
    let stringData = localStorage.getItem(niceResultName)
    return (stringData) ? JSON.parse(stringData) : stringData;
}

const deleteNiceResultInLocalStorage = () => {
    localStorage.removeItem(niceResultName);
};

export {
    setNiceResultInLocalStorage,
    getlocalStorageNiceResult,
    deleteNiceResultInLocalStorage,
}